<label for="{{parentId}}" class="switch" (click)="onCheckChanges(); $event.stopPropagation()" title="{{title | translate}}">
  <input id="{{parentId}}" type="checkbox" [disabled]="disabled" [(ngModel)]="value">
  <span class="slider round"></span>
</label>
